import { Stethoscope, UserRound } from "lucide-react";
import { cn } from "../../utils/utils";
import useBrandTranslation from "../../hooks/useBrandTranslation";
import useDoctorMode, { DOCTOR_MODE } from "../../hooks/useDoctorMode";

// Segmentado "Profesional | Paciente" para que un doctor alterne entre operar
// como profesional o como paciente. Comparte estado vía useDoctorMode.
export default function DoctorModeSwitch({ className, onChange }) {
  const { t } = useBrandTranslation();
  const [mode, setMode] = useDoctorMode();

  const renderOption = (value, label, Icon) => (
    <button
      type="button"
      aria-pressed={mode === value}
      onClick={() => {
        setMode(value);
        onChange?.(value);
      }}
      className={cn(
        "flex-1 flex items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium transition-colors",
        mode === value
          ? "bg-white text-gray-900 shadow-sm"
          : "text-gray-600 hover:text-gray-900"
      )}
    >
      <Icon className="h-4 w-4 shrink-0" />
      {label}
    </button>
  );

  return (
    <div className={cn("flex gap-1 rounded-lg bg-gray-100 p-1", className)}>
      {renderOption(
        DOCTOR_MODE.PROFESSIONAL,
        t("home.mode.professional", "Profesional"),
        Stethoscope
      )}
      {renderOption(
        DOCTOR_MODE.PATIENT,
        t("home.mode.patient", "Paciente"),
        UserRound
      )}
    </div>
  );
}
